import { render, staticRenderFns } from "./weight-verification.vue?vue&type=template&id=36866312&"
import script from "./weight-verification.vue?vue&type=script&lang=js&"
export * from "./weight-verification.vue?vue&type=script&lang=js&"
import style0 from "./weight-verification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports